/**
 * Portal Manta · DashFinPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { DashPage } from './DashPage.jsx';
import { FinPage } from './FinPage.jsx';
import { FatoresQualLotePage } from './FatoresQualLotePage.jsx';

const DashFinPage = memo(function DashFinPage_Inner({lote}){
  return(<div style={{flex:1,overflow:'auto'}}>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.12em',textTransform:'uppercase',position:'sticky',top:0,zIndex:2,display:'flex',alignItems:'center',gap:8}}>
      <span style={{color:'#F4A76A',fontFamily:'monospace'}}>A</span>
      <span style={{color:'rgba(255,255,255,.3)'}}>·</span>
      <span>Dashboard CAPEX</span>
    </div>
    <DashPage lote={lote}/>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderTop:'1px solid rgba(255,255,255,.05)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.12em',textTransform:'uppercase',display:'flex',alignItems:'center',gap:8}}>
      <span style={{color:'#F4A76A',fontFamily:'monospace'}}>B</span>
      <span style={{color:'rgba(255,255,255,.3)'}}>·</span>
      <span>Financeiro</span>
    </div>
    <FinPage lote={lote}/>
    <div style={{padding:'9px 17px',background:'linear-gradient(90deg,#1E2A4A,#2D3F6B)',borderTop:'1px solid rgba(255,255,255,.05)',borderBottom:'1px solid rgba(255,255,255,.1)',fontSize:10,fontWeight:700,color:'rgba(255,255,255,.9)',letterSpacing:'.12em',textTransform:'uppercase',display:'flex',alignItems:'center',gap:8}}>
      <span style={{color:'#F4A76A',fontFamily:'monospace'}}>C</span>
      <span style={{color:'rgba(255,255,255,.3)'}}>·</span>
      <span>Fatores Qualitativos × Orçamento</span>
    </div>
    <FatoresQualLotePage lote={lote}/>
  </div>);
});

export { DashFinPage };
export default DashFinPage;
